import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { formatApiErrorDetail } from "../lib/api";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_supply-control-20/artifacts/rvxe15j7_1.png";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      <div className="relative bg-[#0D2B5E] text-white flex-col justify-between p-10 overflow-hidden hidden lg:flex">
        <div className="absolute inset-0 opacity-15"
          style={{
            backgroundImage: "url('https://static.prod-images.emergentagent.com/jobs/383b1df6-cef7-4216-9145-ffe5c19d4e80/images/e522955680e7523b309d2743798c91863be0b5f87fc7ec4e4baa79a4eade9364.png')",
            backgroundSize: "cover", backgroundPosition: "center",
          }}
        />
        <div className="relative z-10">
          <div className="bg-white rounded-sm p-3 inline-block mb-12">
            <img src={LOGO_URL} alt="Supplar" className="h-16 object-contain"/>
          </div>
          <div className="max-w-md">
            <div className="text-[10px] tracking-[0.3em] text-[#2E7D32] font-bold mb-4 uppercase">
              Single Warehouse · FIFO · QR Traceability
            </div>
            <h1 className="text-4xl font-bold leading-tight mb-4">
              Gate Entry → GRN → Quality → Stock → Outward.
            </h1>
            <p className="text-white/70 text-sm leading-relaxed">
              Scan. Approve. Dispatch. Built for the shop floor, engineered for audit-grade traceability.
            </p>
          </div>
        </div>
        <div className="relative z-10 text-[10px] tracking-[0.2em] text-white/50 uppercase">
          v2.0 — Confidential · Authorised access only
        </div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16 bg-white">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="text-[10px] tracking-[0.3em] text-[#1565C0] font-bold mb-2 uppercase">Sign In</div>
            <h2 className="text-3xl font-bold text-[#0D2B5E]">Welcome back.</h2>
            <p className="text-sm text-[#0D2B5E]/60 mt-2">Enter your credentials to access the control system.</p>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="block text-[10px] tracking-widest uppercase text-[#0D2B5E]/60 font-bold mb-2">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
                className="w-full bg-transparent border-0 border-b-2 border-[#EEEEEE] focus:border-[#1565C0] outline-none py-2 text-[#0D2B5E] font-mono text-sm"
                placeholder="you@supplar.com"/>
            </div>
            <div>
              <label className="block text-[10px] tracking-widest uppercase text-[#0D2B5E]/60 font-bold mb-2">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
                className="w-full bg-transparent border-0 border-b-2 border-[#EEEEEE] focus:border-[#1565C0] outline-none py-2 text-[#0D2B5E] font-mono text-sm"/>
            </div>
            {err && <div className="text-[#C62828] text-sm border border-[#C62828]/30 bg-[#C62828]/5 px-3 py-2 rounded-sm" data-testid="login-error">{err}</div>}
            <button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full bg-[#1565C0] hover:bg-[#0D2B5E] text-white font-semibold tracking-wider uppercase text-sm py-3 rounded-sm transition-colors disabled:opacity-50">
              {loading ? "Authenticating…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
